import React, {useState} from 'react';
import OurStorySec from './ourstorysections/OurStorySec';
import Section1 from './homesections/Section1';
import Section2 from './homesections/Section2';
import AdministrativeBurden from "../assets/images/AdministrativeBurden.svg";
import OptimizeRepeat from "../assets/images/OptimizeRepeat.svg";
import MessagingTool from "../assets/images/MessagingTool.svg";
import SharedCare from "../assets/images/SharedCare.svg";
import { Button, Col, Container, Row } from 'react-bootstrap';
import indiciWeb from '../assets/images/myindici-for-providers.webp'
import { Image } from 'antd';
import { Spin } from 'antd';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import LazyLoad from 'react-lazyload';
import styled from "styled-components";
interface Ourstoryprops {
}
export const MyIndiciForProviders: React.FunctionComponent<Ourstoryprops> = (props) => {
    // const pageId1 = useId() 
const TextContainer = styled.div`
text-align: center;
`;
const Title = styled.span`
   display: block;
  /*color: #fff;
  line-height: 90px; */
`;
const [loading, setLoading]=useState(true)
setTimeout(() => {
  setLoading(false); // Hide loader after 8 seconds
}, 3000);
    return (
        <React.Fragment>
            <div style={{background:'white'}} className='pb-5 pbottom'>
            {/* <div className='relative-container'>
            <LazyLoadImage src={indiciWeb} className='w-100'
              placeholderSrc={indiciWeb} alt="Image Alt"/>
            <div className='banner-text'>
            <TextContainer>
                  <Title className="main-heading"> {`myindici `}
                  {`for Providers`}</Title>
                </TextContainer>
            </div>
        </div>  */}
        {loading ? <Spin spinning={loading} style={{fontSize:48}}   fullscreen /> :
        <Section1 background={indiciWeb} title1={`myindici`} title2={`for Providers`} />}
            
            <OurStorySec classname={''}>
                <Row className='shpbgrow py-5 my-padding align-items-center'>
                    <Col sm={12} className='py-5 pbottom'>
                        {/* <h2 className='myindici-heading text-center'>For Providers</h2> */}
                        <h2 className="textHeadingTwo text-center">Used by Leading Kiwi Healthcare Providers</h2>
                    </Col>
                </Row >
            </OurStorySec>
            <Container className='modrenHealth pb-5'>
                <Row className='shpbgrow px-5 pt-3 align-items-center d-flex flex-wrap-reverse'>
                    <Col sm={12} md={12} className=''>
                    <p className='MyIndiciForContextTwo'>The benefits of
                     the myindici patient portal extend to medical practices
                      just as much as to patients. myindici supports a productive and meaningful 
                        patient engagement framework, complementing 
                        in-person 
                        services with powerful virtual tools and care channels.</p>
                    </Col>
                </Row>
            <Row className='shpbgrow py-5 align-items-center d-flex flex-wrap-reverse'>
                    <Col sm={12} md={3}  className="text-center">
                        <Image  className='featuresimages' width={160}  src={AdministrativeBurden} preview={false} />
                    </Col>
                    <Col sm={12} md={9} className="text-center text-md-start my-margin">
                        <span className="mb-5 MyIndiciForProviders">Reduce Your
                         Staff’s Administrative Burden</span>
                        <p className='mt-3 MyIndiciForContext'>For medical practices, using myindici means a reduction in phone calls that admin and clinical staff would typically spend a significant amount of time processing. Instead, patients can book their own appointments without any involvement from practice staff. Likewise, patients can pay their bills online before or after consultations, reducing overhead on the reception staff.</p>
                    </Col>
                </Row >
                <Row className='shpbgrow py-5 align-items-center d-flex flex-wrap-reverse'>
                    <Col sm={12} md={3} className="text-center">
                        <Image  className='featuresimages' width={145} src={OptimizeRepeat} preview={false} />
                    </Col>
                    <Col sm={12} md={9} className="text-center text-md-start my-margin">
                        <span className="mb-3 MyIndiciForProviders">Optimize Repeat Prescription Management</span>
                        <p className='mt-3 MyIndiciForContext'>Likewise, specially designed work flows for repeat prescription requests ensure that these requests can be smoothly triaged, approved and actioned, and the scripts made available to the patient or instantly sent to the relevant pharmacy.</p>
                    </Col>
                </Row>
                <Row className='shpbgrow py-5 align-items-center d-flex flex-wrap-reverse'>
                    <Col sm={12} md={3} className="text-center">
                        <Image  className='featuresimages' width={160}  src={MessagingTool} preview={false} />
                    </Col>
                    <Col sm={12} md={9} className="text-center text-md-start my-margin">
                        <span className="mb-3 MyIndiciForProviders">A Messaging Tool Designed for Meaningful Use</span>
                        <p className='mt-3 MyIndiciForContext'>For messaging, we
                         are keenly aware that such tools can actually
                          increase provider burden, compelling medical 
                          practitioners to spend more and more time working 
                          through their inbox. indici’s specially designed 
                          inbox feature gives providers key 
                          information at a glance(last appointment,
                           last prescription, etc.) with labs, notes, 
                           recalls and tasks all instantly available, 
                           meaning providers don’t need to trawl through
                            patient files to answer queries. Our smart 
                             tools also allow providers to guide patients
                              towards appropriate use of the messaging channel
                               rather than sending queries that would be better 
                               resolved through an appointment.</p>
                    </Col>
                </Row >
                <Row className='shpbgrow py-5 align-items-center d-flex flex-wrap-reverse'>
                    <Col sm={12} md={3} className="text-center">
                        <Image  className='featuresimages' width={145} src={SharedCare} preview={false} />
                    </Col>
                    <Col sm={12} md={9} className="text-center text-md-start my-margin">
                        <span className="mb-3 MyIndiciForProviders ">Shared Care and Patient Empowerment</span>
                        <p className='mt-3 MyIndiciForContext'>myindici integrates seamlessly 
                        with indici’s Shared Care module, allowing patients to play 
                        a meaningful role within their care plans and collaborative 
                        care programs. Once a care plan is created, goals and 
                        activities can be assigned to the patient who can view and 
                        interact with them through their myindici portal. This helps
                         to ensure patients are proactive and engaged when it comes to
                          managing their health, especially with more complex conditions
                           that require extended treatment regimens and careful lifestyle
                            management.</p>
                    </Col>
                </Row>
                {/* <Row className='p-2'>
                    <Col className='d-flex justify-content-center'>
                    <Button
                        className="btn-lg align-items-center getintouch">Get In Touch
                    </Button>
                    </Col>
                </Row> */}
            </Container>
            </div>
        </React.Fragment>
    )
}

export default MyIndiciForProviders;